import SectionMessage from '@atlaskit/section-message';
import FlagGroup from "../../../../../../packages/design-system/flag/examples/constellation/flag-group";
import FlagsInModalDialogExample from "../../../../../../packages/design-system/flag/examples/constellation/flag-group-in-modal-dialog";
import RAW_UNSAFE_atlaskitSLASHsection_message from "!!raw-loader!@atlaskit/section-message";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHflag_group from "!!raw-loader!../../../../../../packages/design-system/flag/examples/constellation/flag-group";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHflag_group_in_modal_dialog from "!!raw-loader!../../../../../../packages/design-system/flag/examples/constellation/flag-group-in-modal-dialog";
import * as React from 'react';
export default {
  SectionMessage,
  FlagGroup,
  FlagsInModalDialogExample,
  RAW_UNSAFE_atlaskitSLASHsection_message,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHflag_group,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHflag_group_in_modal_dialog,
  React
};